<h2 mat-dialog-title class="custom-dialog-title">{{ data.title }}</h2>
<mat-dialog-content class="custom-dialog-content">
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions class="custom-dialog-actions">
  <button mat-button mat-dialog-close (click)="onCancel()">No</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="onConfirm()">Yes</button>
</mat-dialog-actions>